import { AxiosResponse } from 'axios';
import { appContextGet, appContextPut } from './httpCommon/appAxios.service';
import { QBAccountAssociation } from '../types/interfaces/quickbooks.interface';
import { StandardParams } from '../types/interfaces';
import { QUICKBOOKS_ACCOUNT_ASSOCIATION } from '../constants/apiEndpoints';

export const updateQbCustomerReferenceNumber = (accountId: number, customerRefNumber: string): Promise<AxiosResponse<any, any>> => {
  return appContextPut(QUICKBOOKS_ACCOUNT_ASSOCIATION.PUT_ + accountId, {}, { quickBooksCustomerRef: customerRefNumber });
};

export const getQbAssociationList = (params?: StandardParams): Promise<AxiosResponse<QBAccountAssociation[], any>> => {
  return appContextGet(QUICKBOOKS_ACCOUNT_ASSOCIATION.GET, params);
};
